export const SUNROOF = 2;
export const PANORAMIC_ROOF = 4;
export const ROOF_BARS = 98;
export const TRAILER_HITCH = 24;
export const KEYLESS_ENTRY = 87;
export const HAS_ALLOY_RIMS = 'hasAlloyRims';
export const HAS_SPORT_PACKAGE = 'hasSportPackage';
